import React from 'react'
import '../../../App.css'
import './sponsors.css'
import { SponsorContainer, SponsorGigaLogo, SponsorGrid, SponsorLink, SponsorMegaWideLogo, SponsorKiloSquareLogo,SponsorMegaSquareLogo, SponsorMegaLogo, SponsorHeader, SponsorKiloWideLogo, SponsorKiloLogo } from './sponsorElements'
import PartnershipCard from '../partnershipCard'
import ScrollToTop from '../scrollbutton'

//Previous sponsors / partners
import mmie from '../../../assets/images/sponsors/mmie.jpg'
import sherpa from '../../../assets/images/sponsors/sherpa.png'
import Aquanow from '../../../assets/images/sponsors/Aquanow.png'
import DistributedComputeLabs from '../../../assets/images/sponsors/DistributedComputeLabs.png'
import Kuzo from '../../../assets/images/sponsors/Kuzo.png'
import Microsoft from '../../../assets/images/sponsors/Microsoft.png'
import balsamiq from '../../../assets/images/sponsors/balsamiq.png'
import flik from '../../../assets/images/sponsors/flik.png'
import godaddy from '../../../assets/images/sponsors/godaddy.png'
import Protoio from '../../../assets/images/sponsors/Protoio.svg'
import Rogers from '../../../assets/images/sponsors/Rogers.png'
import Stickermule from '../../../assets/images/sponsors/Stickermule.png'
import TheCodex from '../../../assets/images/sponsors/TheCodex.jpg'
import Toyota from '../../../assets/images/sponsors/Toyota.png'

import Deloitte from '../../../assets/images/sponsors/deloitte.png'
import Loopio from '../../../assets/images/sponsors/loopio.png'
import Nationalbank from '../../../assets/images/sponsors/nationalbank.png'
import SnapChat from '../../../assets/images/sponsors/snapchat.png'
import Sunlife from '../../../assets/images/sponsors/sunlife.jpg'
import Tdbank from '../../../assets/images/sponsors/tdBank.png'
import Tucows from '../../../assets/images/sponsors/tucows.png'
import Telus from '../../../assets/images/sponsors/telus.png'
import Google from '../../../assets/images/sponsors/google.png'
import Shopify from '../../../assets/images/sponsors/shopify.png'
import BMO from '../../../assets/images/2022_sponsors/bmo.png'




import Voiceflow from '../../../assets/images/2022_sponsors/voiceflow.png'
import Mosiac from '../../../assets/images/2022_sponsors/mosaic.png'
import PwC from '../../../assets/images/2022_sponsors/pwc.png'
import ibm from '../../../assets/images/2022_sponsors/ibm.png'
import kingston from '../../../assets/images/2022_sponsors/kingston.svg'
import mlhblack from '../../../assets/images/2022_sponsors/mlh-black.svg'
import Fdm from '../../../assets/images/2022_sponsors/fdm.jpg'
import DDQIC from '../../../assets/images/2022_sponsors/ddqic.jpg'
import Echo3D from '../../../assets/images/2022_sponsors/echo3d.png'
import Amazon from '../../../assets/images/2022_sponsors/amazon.png'
import Amd from '../../../assets/images/2022_sponsors/amd.png'
import Bounce from '../../../assets/images/2022_sponsors/bounce.png'
import ECE from '../../../assets/images/2022_sponsors/ece.png'
import Gameloft from '../../../assets/images/2022_sponsors/gameloft.jpg'
import Hotg from '../../../assets/images/2022_sponsors/hotg.png'
import Mapbox from '../../../assets/images/2022_sponsors/mapbox.png'
import Mars from '../../../assets/images/2022_sponsors/mars.png'
import Redbull from '../../../assets/images/2022_sponsors/redbull.png'
import LeadingLearners from '../../../assets/images/2022_sponsors/leadinglearners.png'
import Soc from '../../../assets/images/2022_sponsors/school_of_computing.jpg'
import Scotiabank from '../../../assets/images/2022_sponsors/scotiabank.jpg'
import SmileCDR from '../../../assets/images/2022_sponsors/smileCDR.png'
import Stan from '../../../assets/images/2022_sponsors/stan.png'
import Whoosh from '../../../assets/images/2022_sponsors/whoosh.png'
import Convictional from '../../../assets/images/2022_sponsors/convictional.png'
import Assemblyai from '../../../assets/images/2022_sponsors/assemblyai.png'



const SponsorsList = () => {
    return (
<div
    >

        <SponsorContainer className="sidePadding">
        <SponsorHeader>Our Sponsors</SponsorHeader>


        <div
            style={{
                color: "#00205B",
                width: "100%",
                borderRadius: "15px",
                background: "#00205B",
                textAlign: "center",
                padding: "15px 0"
            }}
            >
            <h1  
            
            style={{
                color: "#fff",
                textAlign: "center"
            }}
            >Current Sponsors</h1>
         </div>
        <SponsorGrid>

          {/* Giga */}
            <SponsorLink id="scotiaCont" href="https://www.scotiabank.com/careers/en/careers.html" target="_blank" rel="noreferrer" style={{width:"", height:""}}>
                <SponsorGigaLogo id="scotia" src={Scotiabank} alt="Scotiabank" style={{width:"", height:"", margin:""}}/>
            </SponsorLink>
            <SponsorLink id="smileCont" href="https://www.smilecdr.com/careers" target="_blank" rel="noreferrer" style={{width:"", height:""}}>
                <SponsorGigaLogo id="smile" src={SmileCDR} alt="SmileCDR" style={{width:"", height:"", margin:""}}/>
            </SponsorLink>
            {/* Mega */}
            <SponsorLink id="HotgCont"href="https://hotg.ai/" target="_blank" rel="noreferrer" style={{width:"", height:""}}>
                <SponsorMegaLogo id="Hotg" src={Hotg} alt="Hotg" style={{width:"", height:"", margin:""}}/>
            </SponsorLink>
            <SponsorLink id="amazonCont"href="https://www.amazon.jobs/en/" target="_blank" rel="noreferrer" style={{width:"", height:""}}>
                <SponsorMegaLogo id="amazon" src={Amazon} alt="Amazon" style={{width:"", height:"", margin:""}}/>
            </SponsorLink>
            <SponsorLink id="convictionalCont"href="https://jobs.ashbyhq.com/convictional" target="_blank" rel="noreferrer" style={{width:"", height:""}}>
                <SponsorMegaWideLogo id="convictional" src={Convictional} alt="Convictional" style={{width:"", height:"", margin:""}}/>
            </SponsorLink>
            

            {/* Kilo */}
            <SponsorLink id="fdmCont"href="https://www.fdmgroup.com/en-ca/ca-careers/" target="_blank" rel="noreferrer" style={{width:"", height:""}}>
                <SponsorKiloLogo id="fdm" src={Fdm} alt="FDM" style={{width:"", height:"", margin:""}}/>
            </SponsorLink>

            <SponsorLink id="mosaicCont" href="https://www.mosaicmfg.com/" target="_blank" rel="noreferrer" style={{width:"", height:""}}>
                <SponsorKiloLogo id="mosaic"src={Mosiac} alt="Mosiac" style={{width:"", height:"", margin:""}}/>
            </SponsorLink>
            <SponsorLink id="bounceCont" href="https://www.bouncelife.com/" target="_blank" rel="noreferrer" style={{width:"", height:""}}>
                <SponsorKiloLogo id="bounce" src={Bounce} alt="" style={{width:"", height:"", margin:""}}/>
            </SponsorLink> 

            <SponsorLink id="stanCont" href="https://www.stanintelligence.com/" target="_blank" rel="noreferrer" style={{width:"", height:""}}>
                <SponsorKiloLogo id="stan" src={Stan} alt="STAN" style={{width:"", height:"", margin:""}}/>
            </SponsorLink> 

            <SponsorLink id="marsCont" href="https://marsdd.com/" target="_blank" rel="noreferrer" style={{width:"", height:""}}>
                <SponsorKiloSquareLogo id="mars" src={Mars} alt="Mars" style={{width:"", height:"", margin:""}}/>
            </SponsorLink> 

            <SponsorLink id="gameloftCont" href="https://www.gameloft.com/corporate/en/jobs/apply/" target="_blank" rel="noreferrer" style={{width:"", height:""}}>
                <SponsorKiloSquareLogo id="gameloft" src={Gameloft} alt="Gameloft" style={{width:"", height:"", margin:""}}/>
            </SponsorLink> 

            <SponsorLink id="mapboxCont" href="https://www.mapbox.com/careers" target="_blank" rel="noreferrer" style={{width:"", height:""}}>
                <SponsorKiloLogo id="mapbox" src={Mapbox} alt="Mapbox" style={{width:"", height:"", margin:""}}/>
            </SponsorLink> 

            <SponsorLink href="https://www.pwc.com/ca/en/careers.html" target="_blank" rel="noreferrer" style={{width:"", height:""}}>
                <SponsorKiloLogo id="pwc" src={PwC} alt="PwC" style={{width:"", height:"", padding:""}}/>
            </SponsorLink>


            {/* In-Kind */}
        </SponsorGrid>
        <div
            style={{
                color: "#c81c2e",
                width: "100%",
                borderRadius: "15px",
                background: "#c81c2e",
                border: "1px solid #c81c2e",
                textAlign: "center",
                padding: "15px 0"
            }}
            >
            <h1  
            
            style={{
                color: "#fff",
                textAlign: "center"
            }}
            >Our Partners</h1>
         </div>
        <SponsorGrid style={{
                // borderColor: "#c81c2e"
        }}>
            {/* PARTNERS */}
            <SponsorLink href="https://innovation-challenge.cityofkingston.ca/" target="_blank" rel="noreferrer">
                <SponsorMegaLogo id="kingston" src={kingston} alt="kingston" />
            </SponsorLink>
             <SponsorLink href="https://mlh.io/" target="_blank" rel="noreferrer" style={{width:"", height:"", padding:""}}>
                <SponsorMegaLogo src={mlhblack} alt="mlhblack" style={{width:"", height:"", padding:""}}/>
            </SponsorLink>
            <SponsorLink href="https://queensu.ca/innovationcentre" target="_blank" rel="noreferrer" style={{width:"", height:"", margin:""}}>
                <SponsorMegaLogo id="ddqic" src={DDQIC} alt="DDQIC" style={{width:"", height:"", padding:""}}/>
            </SponsorLink>              
            <SponsorLink href="https://www.ece.queensu.ca/about-us/employment-opportunities.html" target="_blank" rel="noreferrer" style={{width:"", height:"", margin:""}}>
                <SponsorMegaSquareLogo id="ece" src={ECE} alt="ECE" style={{width:"", height:"", padding:""}}/>
            </SponsorLink>   
            <SponsorLink href="https://smith.queensu.ca/grad_studies/mei/" target="_blank" rel="noreferrer" style={{width:"", height:"", margin:""}}>
                <SponsorMegaLogo id="smith" src={mmie} alt="mmie" style={{width:"", height:"", padding:""}}/>
            </SponsorLink> 
            <SponsorLink href="https://www.cs.queensu.ca/" target="_blank" rel="noreferrer" style={{width:"", height:"", margin:""}}>
                <SponsorMegaSquareLogo id="soc" src={Soc} alt="Soc" style={{width:"", height:"", padding:""}}/>
            </SponsorLink>       
    
            
            {/* In-Kind */}
            <SponsorLink id="amdCont" href="https://www.amd.com/en/corporate/careers" target="_blank" rel="noreferrer" style={{width:"", height:""}}>
                <SponsorKiloLogo id="amd" src={Amd} alt="Amd" style={{width:"", height:""}}/>
            </SponsorLink>
            <SponsorLink id="learnersCont" href="https://www.leadlearners.ca/" target="_blank" rel="noreferrer" style={{width:"", height:""}}>
                <SponsorKiloLogo id="learners" src={LeadingLearners} alt="LeadingLearners" style={{width:"", height:""}}/>
            </SponsorLink>
            <SponsorLink id="assemblyaiCont" href="https://apply.workable.com/assemblyai/" target="_blank" rel="noreferrer" style={{width:"", height:""}}>
                <SponsorKiloWideLogo id="assemblyai" src={Assemblyai} alt="Assemblyai" style={{width:"", height:""}}/>
            </SponsorLink>
            <SponsorLink id="redbullCont" href="https://jobs.redbull.com/ca-en" target="_blank" rel="noreferrer" style={{width:"", height:""}}>
                <SponsorKiloLogo id="redbull" src={Redbull} alt="Redbull" style={{width:"", height:""}}/>
            </SponsorLink>
            <SponsorLink id="bmoCont" href="https://jobs.bmo.com/ca/en" target="_blank" rel="noreferrer" style={{width:"", height:""}}>
                <SponsorKiloLogo id="bmo" src={BMO} alt="BMO" style={{width:"", height:""}}/>
            </SponsorLink>
            <SponsorLink href="https://www.ibm.com/ca-en/employment/" target="_blank" rel="noreferrer" style={{width:"", height:"",}}>
                <SponsorKiloLogo id="ibm" src={ibm} alt="IBM" style={{width:"", height:""}}/>
            </SponsorLink>              
            <SponsorLink id="voiceCont" href="https://www.voiceflow.com/" target="_blank" rel="noreferrer" style={{width:"", height:""}}>
                <SponsorKiloLogo id="voice" src={Voiceflow} alt="Voiceflow" style={{width:"", height:""}}/>
            </SponsorLink>
            <SponsorLink id="whooshCont" href="https://ca.whoosh.com/" target="_blank" rel="noreferrer" style={{width:"", height:""}}>
                <SponsorKiloWideLogo id="whoosh" src={Whoosh} alt="Whoosh" style={{width:"", height:""}}/>
            </SponsorLink>
            <SponsorLink id="echoCont" href="https://www.echo3d.co/" target="_blank" rel="noreferrer" style={{width:"", height:""}}>
                <SponsorKiloLogo id="echo" src={Echo3D} alt="Echo3D" style={{width:"", height:""}}/>
            </SponsorLink>

        </SponsorGrid>
        <div
            style={{
                color: "#fff",
                width: "100%",
                borderRadius: "15px",
                background: "#fedb01",
                border: "1px solid #fedb01",
                textAlign: "center",
                padding: "15px 0"
            }}
            >
            <h1  
            style={{
                color: "#000",
                textAlign: "center"
            }}
            >Past Sponsors</h1>
        </div>
        <SponsorGrid>
            <SponsorLink href="https://jobs.rogers.com/" target="_blank" rel="noreferrer" style={{width:"", height:""}}>
                <SponsorKiloWideLogo src={Rogers} alt="Rogers" />
            </SponsorLink>

            <SponsorLink href="https://careers.godaddy.com/" target="_blank" rel="noreferrer" style={{width:"", height:"", margin:""}}>
                <SponsorKiloWideLogo id="godaddy" src={godaddy} alt="GoDaddy" style={{height:"", margin:""}}/>
            </SponsorLink>
            <SponsorLink href="https://careers.microsoft.com/us/en" target="_blank" rel="noreferrer" style={{width:"", height:""}}>
                <SponsorKiloWideLogo src={Microsoft} alt="Microsoft" />
            </SponsorLink>             
            <SponsorLink id="shopCont" href="https://www.shopify.ca/careers" target="_blank" rel="noreferrer" style={{width:"", height:"", margin:""}}>
                <SponsorKiloWideLogo id="shop" src={Shopify} alt="Shopify" style={{width:"", height:"", margin:""}}/>
            </SponsorLink>
            <SponsorLink id="googleCont" href="https://careers.google.com/" target="_blank" rel="noreferrer" style={{width:"", height:"", margin:""}}>
                <SponsorKiloWideLogo id="google" src={Google} alt="Google" style={{width:"", height:"", margin:""}}/>
            </SponsorLink>
            <SponsorLink id="snapCont" href="https://careers.snap.com/" target="_blank" rel="noreferrer" style={{width:"", height:"", margin:""}}>
                <SponsorKiloSquareLogo id="snap" src={SnapChat} alt="SnapChat" style={{width:"", height:"", margin:""}}/>
            </SponsorLink>
            <SponsorLink id="deloitteCont" href="https://careers.deloitte.ca/" target="_blank" rel="noreferrer" style={{width:"", height:"", margin:""}}>
                <SponsorKiloWideLogo id="deloitte" src={Deloitte} alt="Deloitte" style={{width:"", height:"", margin:""}}/>
            </SponsorLink>
            <SponsorLink id="loopioCont" href="https://loopio.com/careers/" target="_blank" rel="noreferrer" style={{width:"", height:"", margin:""}}>
                <SponsorKiloWideLogo id="loopio" src={Loopio} alt="Loopio" style={{width:"", height:"", margin:""}}/>
            </SponsorLink>
            <SponsorLink id="nationalCont" href="https://jobs.nbc.ca/" target="_blank" rel="noreferrer" style={{width:"", height:"", margin:""}}>
                <SponsorKiloWideLogo id="national" src={Nationalbank} alt="Nationalbank" style={{width:"", height:"", margin:""}}/>
            </SponsorLink>

            <SponsorLink id="sunlifeCont" href="https://www.sunlife.ca/en/careers/" target="_blank" rel="noreferrer" style={{width:"", height:"", margin:""}}>
                <SponsorKiloWideLogo id="sunlife" src={Sunlife} alt="Sunlife" style={{width:"", height:"", margin:""}}/>
            </SponsorLink>
            <SponsorLink id="tdbankCont" href="https://jobs.td.com/en-CA/" target="_blank" rel="noreferrer" style={{width:"", height:"", margin:""}}>
                <SponsorKiloWideLogo id="tdbank" src={Tdbank} alt="Tdbank" style={{width:"", height:"", margin:""}}/>
            </SponsorLink>
            <SponsorLink id="telusCont" href="https://www.telus.com/en/about/careers" target="_blank" rel="noreferrer" style={{width:"", height:"", margin:""}}>
                <SponsorKiloWideLogo id="telus" src={Telus} alt="Telus" style={{width:"", height:"", margin:""}}/>
            </SponsorLink>
            <SponsorLink id="tucowsCont" href="https://tucows.com/careers/" target="_blank" rel="noreferrer" style={{width:"", height:"", margin:""}}>
                <SponsorKiloWideLogo id="tucows" src={Tucows} alt="Tucows" style={{width:"", height:"", margin:""}}/>
            </SponsorLink>
            <SponsorLink href="https://aquanow.io/" target="_blank" rel="noreferrer" style={{width:"", height:"", margin:""}}>
                <SponsorKiloWideLogo src={Aquanow} alt="Aquanow" style={{width:"", height:""}}/>
            </SponsorLink>

            <SponsorLink href="https://www.stickermule.com/ca/careers" target="_blank" rel="noreferrer" style={{ }}>
                <SponsorKiloSquareLogo src={Stickermule} alt="Stickermule" />
            </SponsorLink>
            <SponsorLink href="https://distributed.computer/" target="_blank" rel="noreferrer" style={{margin: "" }}>
                <SponsorKiloSquareLogo src={DistributedComputeLabs} alt="DistributedComputeLabs" style={{ width:"", height:""}}/>
            </SponsorLink>
            
            <SponsorLink href="https://thecodex.me/" target="_blank" rel="noreferrer" style={{ }}>
                <SponsorKiloSquareLogo src={TheCodex} alt="TheCodex" />
            </SponsorLink>
            <SponsorLink href="https://weareflik.com/" target="_blank" rel="noreferrer" style={{ }} >
                <SponsorKiloSquareLogo src={flik} alt="flik" />
            </SponsorLink>
            <SponsorLink href="https://balsamiq.com/" target="_blank" rel="noreferrer" style={{width:"", height:""}}>
                <SponsorKiloLogo src={balsamiq} alt="balsamiq"  style={{width:"", height:""}}/>
            </SponsorLink>
            <SponsorLink href="https://www.joinsherpa.com/" target="_blank" rel="noreferrer" style={{width:"", height:""}}>
                <SponsorKiloLogo src={sherpa} alt="sherpa" style={{width:"", height:""}}/>
            </SponsorLink>
            <SponsorLink href="https://www.toyota.ca/toyota/en/about/careers" target="_blank" rel="noreferrer" style={{width:"", height:""}}>
                <SponsorKiloLogo src={Toyota} alt="Toyota" style={{width:"", height:""}}/>
            </SponsorLink>
            <SponsorLink id="kuzoCont" href="https://kuzoclass.com/" target="_blank" rel="noreferrer" style={{width:"", height:"", margin:""}}>
                <SponsorKiloLogo id="kuzo" src={Kuzo} alt="Kuzo" style={{width:"", height:"", margin:""}}/>
            </SponsorLink>
            <SponsorLink href="https://proto.io/" target="_blank" rel="noreferrer" style={{width:"", height:""}}>
                <SponsorKiloLogo id="protio" src={Protoio} alt="Protoio" style={{width:"", height:"", margin:""}}/>
            </SponsorLink> 











         </SponsorGrid>
         <section  id="partnerPackage">
            <PartnershipCard/>
         </section>

        </SponsorContainer>
        <ScrollToTop/>
</div>
        
    )
}

export default SponsorsList
            